import { useMemo } from 'react';
import { useBootstrapState } from '../bootstrap/bootstrap-provider';
import { globalAttributes } from '../common/global-attributes';

export function useFrEventsListAgencyTypeOptions() {
    const { userAgencyTypeGlobalAttrId } = useBootstrapState();

    return useMemo(() => {
        return [
            ...(userAgencyTypeGlobalAttrId === globalAttributes.agencyTypeGlobal.POLICE
                ? [
                      {
                          value: 'POLICE',
                          label: 'Police',
                      },
                  ]
                : []),
            {
                value: 'FIRE',
                label: 'Fire',
            },
            {
                value: 'MEDICAL',
                label: 'EMS',
            },
        ];
    }, [userAgencyTypeGlobalAttrId]);
}
